export default "__VITE_ASSET__qEd3KphM__"